// Argus — autoActionsStore: one-shot trigger map for panel actions on open.
// Folosit de quick action buttons din sidebar AgentCard pentru a trigger automat
// o acțiune (screenshot / snap picture) când panel-ul se deschide.
//
// Pattern:
//   1. Caller setează acțiunea: setAutoAction(`${agentId}:${panelType}`, 'screenshot')
//   2. Caller invocă openPanel(...) — panel-ul se montează
//   3. Panel useEffect on mount: consume → execută acțiunea
//   4. consume() șterge entry-ul din map (one-shot, NU se repetă la re-mount)

import { create } from 'zustand';

export type AutoAction = 'screenshot' | 'snap-picture';

interface AutoActionsState {
  pending: Map<string, AutoAction>;
  setAutoAction: (windowKey: string, action: AutoAction) => void;
  consume: (windowKey: string) => AutoAction | undefined;
}

export const useAutoActionsStore = create<AutoActionsState>((set, get) => ({
  pending: new Map(),
  setAutoAction: (windowKey, action) => {
    const next = new Map(get().pending);
    next.set(windowKey, action);
    set({ pending: next });
  },
  consume: (windowKey) => {
    const action = get().pending.get(windowKey);
    if (action !== undefined) {
      const next = new Map(get().pending);
      next.delete(windowKey);
      set({ pending: next });
    }
    return action;
  },
}));
